module.exports = __webpack_public_path__ + "img/main_header_upper_logo.952d862e.svg";